import cx from 'classnames';
import React, { FC } from 'react';

import { ButtonAnchorProps, ButtonProps } from '@/helpers/Button/typings';
import { ButtonPrimary } from '@/components/atoms/ButtonPrimary/render';
import { ButtonSecondary } from '@/components/atoms/ButtonSecondary/render';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type HeaderListAnchorProps = {
	ticket?: ButtonProps;
	anchors?: Array<ButtonAnchorProps>;
};

/**
 * COMPONENT
 */
export const HeaderListAnchor: FC<HeaderListAnchorProps> & BlockConfigs = ({
	ticket = null,
	anchors = [],
}) => {
	const rootClass = cx('supt-headerListAnchor', getStyles());

	return (
		<div className={rootClass} data-block={block.slug}>
			<div className="supt-headerListAnchor__list">
				{ticket && <ButtonPrimary {...ticket} />}
				{anchors.map((anchor, i) => (
					<ButtonSecondary key={i} {...anchor} />
				))}
			</div>
		</div>
	);
};

HeaderListAnchor.slug = block.slug;
HeaderListAnchor.title = block.title;
